import React from 'react';

import Column from '../../common/layout/Column';
import SidePanelContentSection from '../../common2/side-panel/SidePanelContentSection';
import ExternalLink from '../../common2/links/ExternalLink';

function TakeActionDocuments(props) {
  const { customerResponse } = props;

  return (
    <SidePanelContentSection heading="Supporting files">
      <Column spacing="extra-small">
        {customerResponse.files.map((file) => (
          <ExternalLink key={file.id} to={file.publicUrl} download={file.name} target="_self">
            {file.name}
          </ExternalLink>
        ))}
      </Column>
    </SidePanelContentSection>
  );
}

export default React.memo(TakeActionDocuments);
